import { useEffect } from "react";
import { useIsSmartEdit, usePageMetadata } from "~/app/config/pageMetadataContext";

const PAGE_UID_EXCLUSION_PATTERN = /[^a-zA-Z0-9-_]/g;

export function SmartEditBodyClasses() {
  const smartEdit = usePageMetadata()?.smartEdit;
  const inSmartEdit = useIsSmartEdit();

  useEffect(() => {
    if (!inSmartEdit || !smartEdit) {
      return;
    }

    const classes = [
      `smartedit-page-uid-${smartEdit.pageUid.replace(PAGE_UID_EXCLUSION_PATTERN, "-")}`,
      `smartedit-page-uuid-${smartEdit.pageUuid}`,
      `smartedit-catalog-version-uuid-${smartEdit.catalogVersionUuid}`,
    ];
    document.body.classList.add(...classes);

    return () => document.body.classList.remove(...classes);
  }, [inSmartEdit, smartEdit]);

  return null;
}
